import Vue from "vue";
import axios from "axios";

const http = axios.create({
  baseURL: process.env.NODE_ENV === "production"
    ? "https://api.sigfrotagov.com.br"
    : "http://localhost:3010",
});

// Interceptor para injetar o token em cada requisição
http.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Vue.use({
  install(Vue) {
    Vue.prototype.$http = http;
  },
});

export default http;
